var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonaire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9798 74.98C20.1148 129.845 -4.63219 203.419 0.720809 275.165L275.164 0.722029C203.418 -4.63197 129.845 20.115 74.9798 74.98V74.98Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4102 452.071C191.991 536.693 342.35 531.688 437.02 437.019C531.69 342.35 536.695 191.99 452.072 91.4099L91.4102 452.071Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.087 245.689L277.148 233.739L255.087 221.789C249.936 188.328 223.498 161.889 190.037 156.739L178.086 134.677L166.136 156.738C132.676 161.888 106.238 188.327 101.086 221.788L79.0244 233.739L101.085 245.689C106.236 279.15 132.674 305.589 166.135 310.739L178.086 332.801L190.036 310.74C223.498 305.589 249.936 279.15 255.087 245.689V245.689ZM178.087 278.261C153.498 278.261 133.565 258.329 133.565 233.739C133.565 209.149 153.497 189.217 178.087 189.217C202.677 189.217 222.609 209.149 222.609 233.739C222.609 258.329 202.676 278.261 178.087 278.261Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.087 200.348L187.726 217.043H207.005L197.365 233.739L207.005 250.435H187.726L178.087 267.13L168.448 250.435H149.17L158.809 233.739L149.17 217.043H168.448L178.087 200.348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonaire);
export default __webpack_public_path__ + "static/media/bonaire.5d36d49271840282888074d1e6936e86.svg";
export { ForwardRef as ReactComponent };